import { useDispatch, useSelector } from 'react-redux';

import { openAIChat, setActiveWorkflow, WorkflowTypes } from 'handlers/aiChat';
import { resetAiCoachConversation } from 'handlers/aiCoachConversation';
import { getAiCoachConversation } from 'selectors/getAiCoachConversation';

const useOpenAiCoachConversationChat = () => {
  const dispatch = useDispatch();
  const { terminal } = useSelector(getAiCoachConversation);

  return () => {
    // Resume an in-progress conversation; start fresh only if the previous one ended.
    if (terminal) dispatch(resetAiCoachConversation());

    dispatch(openAIChat());
    dispatch(
      setActiveWorkflow({
        success: false,
        type: WorkflowTypes.Conversation,
      }),
    );
  };
};

export default useOpenAiCoachConversationChat;
